import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ClimateCortexModelInitializerService } from '../../../services/climate-cortex-model-initializer.service';

export const climateCortexModelLoadGuard: CanMatchFn = (): Observable<boolean> => {
  const ccModelInitService = inject(ClimateCortexModelInitializerService);
  return ccModelInitService.modelLoaded ? of(true) : ccModelInitService.loadCCModel();
};
